import { request } from "../axios/request";

export const getDepartmentsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/departments", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getAllDepartmentsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/departments", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveDepartmentService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/departments/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/departments", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteDepartmentService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/departments/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
